var _regeneratorRuntime = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/lib/jenkins/jobs/LiDARnetics - Client - PROD_REDUX deploy/workspace/lidarnetics_client_prod_redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var fs = require('fs');

var epsgCheck = require('epsg-index/all.json');

var fetch = require('node-fetch');

var bufferLib = require('buffer/').Buffer;

var bufferFromLocalFile = function bufferFromLocalFile(_ref) {
  var input = _ref.input,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      _ref$end = _ref.end,
      end = _ref$end === void 0 ? 2000 : _ref$end;
  var buffer = new Buffer.alloc(end - start);
  var fileD = fs.openSync(input, 'r');
  fs.readSync(fileD, buffer, 0, end - start, start);
  fs.closeSync(fileD);
  return buffer;
};

var bufferFromUrl = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var input;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            input = _ref2.input;
            _context2.next = 3;
            return fetch(input).then( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                var arrayBuffer, buffer;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return res.arrayBuffer();

                      case 2:
                        arrayBuffer = _context.sent;
                        buffer = bufferLib.from(arrayBuffer);
                        return _context.abrupt("return", {
                          buffer: buffer,
                          arrayBuffer: arrayBuffer
                        });

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }());

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function bufferFromUrl(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var validateEpsg = function validateEpsg(epsg) {
  if (epsgCheck[epsg.toString()]) {
    return true;
  }

  ;
  return false;
};

var bufferFlipper = function bufferFlipper(buf) {
  var ab = new ArrayBuffer(buf.length);
  var view = new Uint8Array(ab);

  for (var i = 0; i < buf.length; ++i) {
    view[i] = buf[i];
  }

  return ab;
};

var uint8arrayToString = function uint8arrayToString(array) {
  var str = '';
  array.forEach(function (item) {
    var c = String.fromCharCode(item);

    if (c !== "\0") {
      str += c;
    }
  });
  return str.trim();
};

var fileObjToBuffer = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var input, _ref5$start, start, _ref5$end, end, arrayBuffer, buffer;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            input = _ref5.input, _ref5$start = _ref5.start, start = _ref5$start === void 0 ? 0 : _ref5$start, _ref5$end = _ref5.end, end = _ref5$end === void 0 ? 2000 : _ref5$end;
            _context3.next = 3;
            return fileObjToArrBuffer({
              input: input,
              start: start,
              end: end
            });

          case 3:
            arrayBuffer = _context3.sent;
            buffer = bufferLib.from(arrayBuffer);
            return _context3.abrupt("return", {
              buffer: buffer,
              arrayBuffer: arrayBuffer
            });

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fileObjToBuffer(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var fileObjToArrBuffer = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var input, start, end;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            input = _ref7.input, start = _ref7.start, end = _ref7.end;
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              var blob = input.slice(start, end);
              var reader = new FileReader();

              reader.onload = function (event) {
                return resolve(event.target.result);
              };

              reader.onerror = reject;
              reader.readAsArrayBuffer(blob);
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fileObjToArrBuffer(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

module.exports = {
  bufferFromLocalFile: bufferFromLocalFile,
  bufferFromUrl: bufferFromUrl,
  validateEpsg: validateEpsg,
  bufferFlipper: bufferFlipper,
  uint8arrayToString: uint8arrayToString,
  fileObjToBuffer: fileObjToBuffer
};